module.exports = __webpack_public_path__ + "static/img/83-2.4bb31ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/83-2.jpg
// module id = PgrO
// module chunks = 0